const FormatQuestions = (formInstance) => {
  var formattedResult = {};
  
  if(formInstance && formInstance.configuration){
    var configuration = JSON.parse(formInstance.configuration);
    var questions = {};
    var questionsAndAnswers = [];
    
    if(configuration.pages){
      let index = 0;
      configuration.pages.forEach((page) => {
        if(page.elements){
          page.elements.forEach((element) => {
            if(element.type && element.titleLocation != "hidden") {
              var questionData = {id: index, type: element.type, title: element.title.replace(/<[^>]+>/g, ''), responseCount: 0, hasOther: element.hasOther, options: element.choices || element.rateValues };
              questions[element.name] = questionData;
              upsertQuestionAndAnswers(questionsAndAnswers, questionData);
              index++;
            }
          });
        }
      });
    
      if(formInstance.instanceParticipants){
        formInstance.instanceParticipants.forEach((participant) => {
          if(participant.answerCount > 0 && participant.completedDate != null && participant.participantStatusId != 3){
            var answers = JSON.parse(participant.answers);
            var answerKeys = Object.keys(answers);
            answerKeys.forEach((questionNumber) => {
              if(questions[questionNumber]) mapAnswersToQuestions(answers, questionNumber, participant.employeeName)
            })
          }
        });
      }
    }

    function mapAnswersToQuestions(answers, questionNumber, employeeName){
      var question = questions[questionNumber]
      var userInputQuestionTypes = ["constantsum", "multilinetext", "stackrank", "dropdown"];
      if(question.options && !userInputQuestionTypes.includes(question.type)){ 
        if(question.hasOther && !question.otherOptionAdded){
          var otherOption = {value: questionNumber, text: "Other"}
          question.options.push(otherOption)
          question["otherOptionAdded"] = true
        }
        question.options.forEach((option) => {
          option.count = option.count ? option.count : 0;
          question.participantResponses = question.participantResponses ? question.participantResponses : [];
          let questionAnswers = answers[questionNumber];
          if (option.value === questionAnswers || (Array.isArray(questionAnswers) && questionAnswers.includes(option.value))){
            option.count++;
            question.participantResponses.push({ employeeName: employeeName, response: option.text });
          }
          else if(question.hasOther && questionAnswers === 'other' && option.text === 'Other'){
            var otherAnswer = answers[questionNumber + "-Comment"];
            option.count++;
            question.participantResponses.push({ employeeName: employeeName, response: otherAnswer });
          }
          else if(question.hasOther && Array.isArray(questionAnswers)){ 
            questionAnswers.forEach(answer => {
              if(answer.toUpperCase() == option.text.toUpperCase()){
                option.count++;
                question.participantResponses.push({ employeeName: employeeName, response: option.text });
              }
            })
          }
        })
      }
      else if(question.options && question.type == "dropdown"){ 
        if(question.hasOther && !question.otherOptionAdded){
            var otherOption = {value: questionNumber, text: "Other"}
            question.options.push(otherOption)
            question["otherOptionAdded"] = true
        }
        question.options.forEach((option) => {
          if(!option.count) option["count"] = 0;
            if (!question.participantResponses) question["participantResponses"] = [];
            let questionAnswers = answers[questionNumber];
            if (option.value === questionAnswers || (Array.isArray(questionAnswers) && questionAnswers.includes(option.value))) {
            option.count++;
            question.participantResponses.push({employeeName: employeeName, response: option.text})
          } 
          
            else if (question.hasOther && option.text.toUpperCase() == questionAnswers.toUpperCase()){
            option.count++;
            question.participantResponses.push({employeeName: employeeName, response: option.text})
         }
        })
      }
      else if(question.options && question.type == "stackrank"){
        question.options.forEach((option) => {
          var questionAnswers = answers[questionNumber];
          var answerIndex = questionAnswers.findIndex(questionAnswer => questionAnswer == option.value);
          if(!option.sum) option["sum"] = 0;
          if(!option.byQuestionRank) option["byQuestionRank"] = new Array(question.options.length).fill(0);
          if(answerIndex > -1){
            var optionValue = question.options.length - answerIndex;
            option.sum += optionValue;
            option.byQuestionRank[answerIndex] += 1;
          } 
        })
      }
      else if(question.options && question.type == "constantsum"){
        question.options.forEach((option) => {
          var questionAnswers = answers[questionNumber];
          var answer = questionAnswers[option.value];
          if(!option.sum) option["sum"] = 0;
          if(!option.constantSumValues) option["constantSumValues"] = [];
          let intAnswer = parseInt(answer)
          option.sum += isNaN(intAnswer) ? 0 : intAnswer;
          if(!isNaN(intAnswer)) option.constantSumValues.push(intAnswer)
        })
      }
      else if(question.options && question.type == "multilinetext"){
        question.options.forEach((option) => {
          if(!question.participantResponses) question["participantResponses"] = [];
          var questionAnswers = answers[questionNumber];
          var optionAnswer = questionAnswers[option.value];
          if(!option.responses) option["responses"] = [];
          option.responses.push({employeeName: employeeName, response: optionAnswer});
          question.participantResponses.push({employeeName: employeeName, response: optionAnswer})
        })
      }
      else{
        if(!question.answers) question["answers"] = [];
        if(!question.participantResponses) question["participantResponses"] = [];
        question.participantResponses.push({employeeName: employeeName, response: answers[questionNumber]})
        question.answers.push(answers[questionNumber]);
      }
      question.responseCount++;
      upsertQuestionAndAnswers(questionsAndAnswers, question)
    }

    function upsertQuestionAndAnswers(questionsAndAnswers, item) { 
      const i = questionsAndAnswers.findIndex(question => question.id === item.id);
      if (i > -1) questionsAndAnswers[i] = item;
      else questionsAndAnswers.push(item);
    }

    questionsAndAnswers.sort((a, b) => {return a.id - b.id});

    formattedResult.questionsAndAnswers = questionsAndAnswers;
    formattedResult.participantCount = formInstance.instanceParticipants.filter(x => x.participantStatusId != 3).length;
    formattedResult.participantsResponded = formInstance.participantsResponded;
    formattedResult.questionCount = questionsAndAnswers.length;
  }
  return formattedResult;
}

export default FormatQuestions;